module.exports = __webpack_public_path__ + "img/accessDenied.7ac36e42.png";